/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Roll live traffic back to a previous deployment.
 */
export type V1DeploymentsRollbackDeploymentRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  deploymentId: string;
};

/** @internal */
export type V1DeploymentsRollbackDeploymentRequestBody$Outbound = {
  deploymentId: string;
};

/** @internal */
export const V1DeploymentsRollbackDeploymentRequestBody$outboundSchema:
  z.ZodType<
    V1DeploymentsRollbackDeploymentRequestBody$Outbound,
    z.ZodTypeDef,
    V1DeploymentsRollbackDeploymentRequestBody
  > = z.object({
    deploymentId: z.string(),
  });

export function v1DeploymentsRollbackDeploymentRequestBodyToJSON(
  v1DeploymentsRollbackDeploymentRequestBody:
    V1DeploymentsRollbackDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeploymentsRollbackDeploymentRequestBody$outboundSchema.parse(
      v1DeploymentsRollbackDeploymentRequestBody,
    ),
  );
}
